export default __webpack_public_path__ + "static/media/GDPR_TKD.d3b3bb05.pdf";